import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef, useRef, useContext, useCallback, useImperativeHandle } from "react";
import PropTypes from "prop-types";
import { RadioWrapper, RadioDisplay, RadioInput, RadioContent, RadioTitle, RadioDescription } from "./radio.styles.es.js";
import { radioContext } from "./radio-context.es.js";
const propTypes = {
  children: PropTypes.string,
  disabled: PropTypes.bool,
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};
const defaultProps = {
  children: void 0,
  disabled: false,
  title: void 0
};
const Radio = forwardRef(
  ({ children, disabled, title, value, ...restProps }, forwardedRef) => {
    const ref = useRef();
    const { allDisabled, name, selectedValue, setValue } = useContext(radioContext);
    const checked = value === selectedValue;
    const isDisabled = allDisabled || disabled;
    const handleChange = useCallback(() => {
      setValue(value);
    }, [value, setValue]);
    useImperativeHandle(forwardedRef, () => ref.current);
    return /* @__PURE__ */ jsxs(RadioWrapper, { ref, disabled: isDisabled, children: [
      /* @__PURE__ */ jsx(RadioDisplay, { checked, disabled: isDisabled, children: /* @__PURE__ */ jsx(
        RadioInput,
        {
          checked,
          disabled: isDisabled,
          name,
          onChange: handleChange,
          value,
          ...restProps
        }
      ) }),
      /* @__PURE__ */ jsxs(RadioContent, { children: [
        title && /* @__PURE__ */ jsx(RadioTitle, { children: title }),
        children && /* @__PURE__ */ jsx(RadioDescription, { hasTitle: Boolean(title), children })
      ] })
    ] });
  }
);
Radio.propTypes = propTypes;
Radio.defaultProps = defaultProps;
export {
  Radio
};
